import { render, staticRenderFns } from "./swichWatchAir.vue?vue&type=template&id=85b95390&scoped=true&"
import script from "./swichWatchAir.vue?vue&type=script&lang=js&"
export * from "./swichWatchAir.vue?vue&type=script&lang=js&"
import style0 from "./swichWatchAir.vue?vue&type=style&index=0&id=85b95390&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b95390",
  null
  
)

export default component.exports